import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import { addMessage } from '../../Slice/Application/ApplicationSlice.js'
import { errorMessage } from '../../../Model/Message/IMessage.js'

export const CreateProjectEpic: Epic = (action$, _state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.createProjectRequest.match),
    mergeMap((action) =>
      ProjectRepository.createProject(action.payload).pipe(
        mergeMap((response) => of(project.createProjectRequestSuccess(response))),
        catchError((error) =>
          of(project.createProjectRequestFailure({ error }), addMessage(errorMessage('Project could not be created. Please try again.')))
        )
      )
    )
  )
